import { formatDateWithWeekday } from "@/lib/displayDateTime";

/** Display helpers for notes/todos timeline cards */

export function formatRelativeTime(iso: string, now = new Date()): string {
  const ms = now.getTime() - new Date(iso).getTime();
  const mins = Math.max(0, Math.floor(ms / 60_000));
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function formatAbsoluteDate(iso: string): string {
  return formatDateWithWeekday(iso);
}

export { formatTodoDueLabel as formatDuePill } from "./todoDueDisplay";

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  /** Match TopActionBar / sidebar: first two words → "Chandra Kalyan B" → CK */
  return (
    parts
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase() ?? "")
      .join("") || "?"
  );
}

export function initialsFromUser(user: {
  first_name?: string | null;
  last_name?: string | null;
  full_name?: string | null;
  email?: string | null;
} | null): string {
  const fullName =
    user?.full_name?.trim() ||
    [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim() ||
    null;
  if (fullName) return initials(fullName);
  return user?.email?.[0]?.toUpperCase() ?? "?";
}
